import DOMPurify from "dompurify";

// Zentrale HTML-Bereinigung fuer jede Stelle, die gerenderte Doku/Markdown ueber
// dangerouslySetInnerHTML oder document.write ausgibt.
//
// ⛔ Anlass: In der Doku-Funktion war Inhalt anderer Nutzer (ueber 24h-Freigabelinks geteilt) roh
// gerendert worden - ein ```svg-Block feuerte ein <img onerror> schon beim Ansehen, der PDF-Druck
// fuehrte <script> aus. DOMPurify laesst HTML UND SVG (die Diagramme) durch, entfernt aber
// <script>, Event-Handler (onerror/onload/onbegin ...) und andere aktive Inhalte.
export function sauberesHtml(html) {
  if (html == null) return "";
  return DOMPurify.sanitize(String(html), {
    USE_PROFILES: { html: true, svg: true, svgFilters: true },
  });
}
